import { cn } from 'lib/helpers/utility';

const PayOnlineButton = ({ className = 'self-end', disabled = false, payrocId }) => {
  return (
    <div
      className={cn(
        'payment-button-submit-wrapper flex items-center',
        disabled && 'pointer-events-none opacity-50',
        className
      )}
      aria-disabled={disabled || undefined}
      {...(disabled && { inert: '' })}>
      <div
        className={cn(
          'card-submit submit-button payroc-card-submit-button h-12',
          payrocId && `payroc-submit-${payrocId}`
        )}
        tabIndex={disabled ? -1 : undefined}
      />
    </div>
  );
};

export default PayOnlineButton;
